import { coinParrotModel } from '@models/coin.parrot.model';
import { normalizeSuiCoinType } from '@utils/index';
import { useModel } from 'foca';
import { useEffect, useState } from 'react';
import { ParrotCoinStruct } from 'src/types';
import { useRefreshTime } from './use-refresh';

export const useParrotInitCoins = () => {
  const [coins, setCoins] = useState<ParrotCoinStruct[]>();
  const { updateIsHttpApi } = useRefreshTime();
  const initCoins = async () => {
    try {
      const result = await coinParrotModel.getHttpAllCoins();
      setCoins(result);
      return true;
    } catch (err) {
      setCoins([]);
      updateIsHttpApi(false);
    }

    return false;
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = async () => {
      const isLoading = await initCoins();
      if (isLoading) {
        timer = setTimeout(() => {
          loop();
        }, 300_000); // 5 minutes
      }
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return coins;
};

export const useParrotCoins = () => {
  const coins = useModel(coinParrotModel, (state) => state.cacheCoins);
  return { coins };
};

export const useParrotCoinsByType = () => {
  const coins = useModel(coinParrotModel, (state) => state.coins);
  return { coins };
};

export const useParrotCoin = (coinType: string | undefined) => {
  const type = coinType ? normalizeSuiCoinType(coinType) : '';
  const coin = useModel(coinParrotModel, (state) => state.coins[type]);

  useEffect(() => {
    !coin && !!type && coinParrotModel.getCoin(type);
  }, [type, coin]);

  return { coin };
};
